let memoryToken: string | null = null;
const storageKey = 'hjrxAdminToken';
const legacyStorageKey = 'adminToken';
const cookieKey = 'hjrxAdminToken';

const resolveStorage = (label: 'localStorage' | 'sessionStorage') => {
  if (typeof window === 'undefined') return null;
  try {
    return window[label];
  } catch (error) {
    console.warn(`[adminToken] access ${label} failed:`, error);
    return null;
  }
};

const safeRead = (label: 'localStorage' | 'sessionStorage') => {
  const storage = resolveStorage(label);
  if (!storage) return null;
  try {
    return storage.getItem(storageKey) || storage.getItem(legacyStorageKey);
  } catch (error) {
    console.warn(`[adminToken] read ${label} failed:`, error);
    return null;
  }
};

const safeWrite = (label: 'localStorage' | 'sessionStorage', token: string) => {
  const storage = resolveStorage(label);
  if (!storage) return;
  try {
    storage.setItem(storageKey, token);
    storage.removeItem(legacyStorageKey);
  } catch (error) {
    console.warn(`[adminToken] set ${label} failed:`, error);
  }
};

const safeRemove = (label: 'localStorage' | 'sessionStorage') => {
  const storage = resolveStorage(label);
  if (!storage) return;
  try {
    storage.removeItem(storageKey);
    storage.removeItem(legacyStorageKey);
  } catch (error) {
    console.warn(`[adminToken] remove ${label} failed:`, error);
  }
};

export const getAdminToken = () => {
  const stored = safeRead('localStorage') ?? safeRead('sessionStorage');
  if (stored) {
    memoryToken = stored;
    return stored;
  }
  if (typeof document !== 'undefined') {
    const match = document.cookie.match(
      new RegExp(`(?:^|; )${cookieKey}=([^;]*)`),
    );
    if (match?.[1]) {
      const token = decodeURIComponent(match[1]);
      memoryToken = token;
      return token;
    }
  }
  return memoryToken;
};

export const setAdminToken = (token: string) => {
  memoryToken = token;
  safeWrite('localStorage', token);
  safeWrite('sessionStorage', token);
  if (typeof document !== 'undefined') {
    document.cookie = `${cookieKey}=${encodeURIComponent(
      token,
    )}; path=/; max-age=31536000; SameSite=Lax`;
  }
};

export const removeAdminToken = () => {
  memoryToken = null;
  safeRemove('localStorage');
  safeRemove('sessionStorage');
  if (typeof document !== 'undefined') {
    document.cookie = `${cookieKey}=; path=/; max-age=0; SameSite=Lax`;
  }
};
